import RecaptchaPlugin from '@0x234/common-vue/plugins/recaptcha-plugin';
import { boot } from 'quasar/wrappers';
import env from 'src/configs/env.js';

export default boot(async ({ app }) => {
    app.use(RecaptchaPlugin, {
        v3SiteKey: env.recaptchaSiteKey,
        axiosClients: [
            app.config.globalProperties.$api,
            app.config.globalProperties.$auth
        ]
    });
});
